<!-- CARGADOR -->
<jqxLoader #loader [imagePosition]="'top'" [width]="60" [height]="60" [text]="'Espere...'">
</jqxLoader>

<div class="panel panel-primary my-1 mx-auto rounded-3 shadow-lg" style="height: 99%">
    <div class="panel-heading clearfix">
        <div class="row">
            <div class="col-md-4"></div>
            <div class="col-md-5">
                <div class="panel-title pull-left">
                    <span style="font-size: x-large;">Edición de menús</span>
                </div>
            </div>
            <div class="col-md-3"></div>
        </div>
    </div>

    <!-- FILTROS -->
    <div class="m-2 p-2 rounded-3 borderFilter" style="height: 50px;">
    </div>

    <!-- TABLA GRID -->
    <div class="container" style="display: flex; gap: 2%; margin-top: 20px; margin-left: 20px; position:relative; ">

        <div class="col-5">
            <h5>Menús</h5>
            <jqxGrid #grid [theme]="environment.tema" [width]="'100%'" [height]="485" [source]="dataAdapter"
                [columnsresize]="true" [localization]="langGrid" [filterable]="true" [showfilterrow]="true"
                [columns]="columns" [showrowlines]="false" [showcolumnlines]="true" [pageable]="false" [sortable]="true"
                [altrows]="true" [showstatusbar]="true" [statusbarheight]="20" [showaggregates]="true" [rowsheight]="20"
                [columnsheight]="20" [enabletooltips]="true" [editable]="false" (onRowclick)="onRowSelect($event)">
            </jqxGrid>
            <div *ngIf="menuSelecId > 0" style="float: left; margin-left: 255px;">
                <input #chbVerMenuOld type="checkbox" (change)="onChangeVerMenuOld($event)" />&nbsp;Ver menú anterior
            </div>
        </div>

        <div *ngIf="opcVisible" class="col-3"
            style="position: absolute; margin-left: 260px; z-index: 999; width: 330px;">
            <h5 style="float: left; background-color: white;">Opciones disponibles</h5>
            <jqxTree #menuOrigin [theme]="environment.tema" [width]="300" [height]="446" [source]="recordsOri"
                [hasThreeStates]="false" [checkboxes]="false" [allowDrag]="true" [allowDrop]="false">
            </jqxTree>
        </div>

        <div [hidden]="!verMenuOld" class="col-3"
            style="position: absolute; margin-left: 0px; z-index: 999; width: 330px;">
            <h5 style="float: left; background-color: white;">Menú anterior</h5>
            <jqxTree #menuOld [theme]="environment.tema" [width]="300" [height]="446" [source]="recordsOld"
                [hasThreeStates]="false" [checkboxes]="false" [allowDrag]="false" [allowDrop]="false">
            </jqxTree>
        </div>

        <div class="col-3">
            <div style="float: left; display: flex; align-items: center;">
                <h5 style="float: left;">Opciones</h5>
                <jqxButton #btnMas style="float: left; margin-top: 0px; margin-left: 10px;" [width]='90' [height]='24'
                    [theme]="environment.tema" [textImageRelation]="'textBeforeImage'" [imgPosition]="'right'"
                    [textPosition]="'left'" [imgSrc]="'/assets/images/opciones.png'" [value]="'Más...'"
                    (onClick)="onCrearOpcion()">
                </jqxButton>
                <div style="position: absolute; margin-left: 265px;">
                    <jqxTree #menuDel style="opacity: 0%; z-index: 999;" [theme]="environment.tema" [width]="50"
                        [height]="50" [hasThreeStates]="false" [checkboxes]="false" [allowDrag]="false"
                        [allowDrop]="true">
                    </jqxTree>
                </div>
                <img src={{imageDelete}} class="movisatLogo"
                    style="float:left; z-index: 0; width: 36px; height: 32px; margin-left: 90px;" />
            </div>
            <jqxTree #menuFinal [theme]="environment.tema" [width]="320" [height]="446" [source]="recordsFin"
                [hasThreeStates]="false" [checkboxes]="false" [allowDrag]="true" [allowDrop]="true"
                (onDragStart)="onDragStart($event)" (onDragEnd)="onDragEnd($event)"
                (onSelect)="onSelectOpciones($event)">
            </jqxTree>
            <div style="display: flex; align-items: center">
                <jqxButton style="margin-top: 10px; float: left; margin-right: 112px;" [width]='90' [height]='26'
                    [theme]="environment.tema" [imgSrc]='"/assets/images/borrar.png"' (onClick)="onBorrarMenu()">
                    Borrar
                </jqxButton>
                <jqxButton style="margin-top: 10px; float: left; margin-right: 0px;" [width]='100' [height]='26'
                    [theme]="environment.tema" [imgSrc]='"/assets/images/save.png"' (onClick)="onGuardar()">
                    Guardar
                </jqxButton>
            </div>
        </div>

        <div class="col-2.5">
            <div style="float: left;">
                <h5>Nombre</h5>
                <jqxInput #ebNombre [width]="300" [height]="25">
                </jqxInput><br>
                <div style="margin-top: 5px;">
                    Observaciones
                    <jqxInput #ebObserv [width]="300" [height]="25">
                    </jqxInput>
                </div>
                <div style="margin-top: 5px;">
                    Acción
                    <jqxDropDownList #cbAcciones [width]="300" [height]="25" [selectedIndex]="0"
                        (onSelect)="onChangeAccion($event)">
                    </jqxDropDownList>
                </div>
                <div style="float: left;">
                    <input #chbSoloMovisat type="checkbox" (change)="onChangeSoloMovisat($event)" />&nbsp;Sólo Movisat
                </div>
                <div style="float: left; clear: both; background-color: beige; width: 300px; color: red;">
                    {{textoSeleccionado}}
                </div>
                <div [hidden]="menuSelecId !== 0 && menuSelecId !== 1"
                    style="margin-top: 67px; border-style: ridge; width: 300px; height: 249px; border-width: 2px;">
                    <h5 style="margin-left: 8px;">Nueva opción</h5>
                    &nbsp;&nbsp;Texto<br>
                    <jqxDropDownList #cbTextoOpcion style="margin-left: 8px;" [width]="280" [height]="25"
                        [selectedIndex]="0">
                    </jqxDropDownList>
                    &nbsp;&nbsp;Acción<br>
                    <jqxDropDownList #cbAccionOpcion style="margin-left: 8px;" [width]="280" [height]="25"
                        [selectedIndex]="0" (onSelect)="onChangeNewAccion($event)">
                    </jqxDropDownList>
                    <div style="float: left; margin-left: 8px;">
                        <input #chbHermana type="checkbox" (change)="onChangeHermana($event)" checked />&nbsp;Hermana
                    </div><br>
                    <div style="float: left; margin-left: 8px;">
                        <input #chbHija type="checkbox" (change)="onChangeHija($event)" />&nbsp;Hija
                    </div><br>
                    <div style="float: left; margin-left: 8px;">
                        <jqxButton style="margin-top: 30px; float: left;" [width]='90' [height]='26'
                            [theme]="environment.tema" [imgSrc]='"/assets/images/mas.png"' (onClick)="onNuevaOpcion()">
                            Crear
                        </jqxButton>
                    </div>
                </div>
            </div>
        </div>

        <div class="col-1" style="width: 180px;">
            <div style="float: left; margin-top: 116px; clear: both;">
                Observaciones
            </div>
            <div
                style="float: left; clear: both; width: 100%; height: 342px; border-width: 2px; background-color: beige; border-style: ridge;">
                {{observacionesAccion}}
            </div>
        </div>
    </div>
</div>